import { FormikValues, useFormikContext } from "formik";
import React, { useState } from "react";

import FormStepTitle from "../../../../common/form/Steps/FormStepTitle";
import DropdownField from "../../../../common/form/dropdown/DropdownField";
import DepartmentAddTitleAndInput from "../DepartmentAddTitileAndInput";

import styles from "./../../styles.module.scss";
import { userStatus } from "../../../../../constants/user";

type Props = {
  inputHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const options = [
  {
    name: userStatus.SUBMITTED,
    label: "Submitted At",
  },
  {
    name: userStatus.APPROVED,
    label: "Approved At",
  },
];

const DepartmentFormStepOne: React.FC<Props> = ({ inputHandler }) => {
  const { values, setFieldValue } = useFormikContext<FormikValues>();

  const [fieldsOptions] = useState(options);

  const expiresOnInputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(e.target.name, e.target.value);
  };

  return (
    <>
      <FormStepTitle title="Department Details" required />
      <DepartmentAddTitleAndInput
        title="Department Name*"
        name="name"
        placeholder="Department Name"
      />

      <DepartmentAddTitleAndInput
        title="Auto Approval Expiry Days*"
        name="expiresIn"
        placeholder="Expiry Days"
        type="number"
      />

      <DepartmentAddTitleAndInput
        title="Max Approved Amount (INR)*"
        name="maxAmount"
        placeholder="Max Approved Amount"
        type="number"
      />

      <h5 className={styles.h5}>Expiry Dependency Field</h5>
      <DropdownField
        name="expiresOn"
        label="Expiry Dependency Field"
        dropDownList={fieldsOptions}
        itemFieldValue="name"
        itemFieldLabel="label"
        value={values?.expiresOn}
        onChange={expiresOnInputHandler}
        sx={{
          "& .MuiInputBase-root": {
            backgroundColor: "#dcdcdc",
            borderRadius: "4px",
          },
        }}
      />
    </>
  );
};

export default DepartmentFormStepOne;
